import { forwardRef, type Ref, type SVGProps } from "react";

function SvgHourGlass(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 176 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_19884_23161)">
        <circle cx="88" cy="60" r="50" stroke="url(#paint0_linear_19884_23161)" strokeWidth="20" />
        <path d="M74 45H101" stroke="#0C1C43" strokeWidth="1.5" />
        <path d="M74 75H101" stroke="#0C1C43" strokeWidth="1.5" />
        <path
          d="M76.9998 75C76.9998 75 76.6489 60.5 87.5002 60.5C98.3515 60.5 98.0006 75 98.0006 75"
          stroke="#0C1C43"
          strokeWidth="1.5"
        />
        <path
          d="M76.9998 45.5C76.9998 45.5 76.6489 60 87.5002 60C98.3515 60 98.0006 45.5 98.0006 45.5"
          stroke="#0C1C43"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_19884_23161"
          x1="88"
          y1="10"
          x2="88"
          y2="110"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#98CCFB" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="clip0_19884_23161">
          <rect x="38" y="10" width="100" height="100" rx="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgHourGlass);
export default ForwardRef;
